import React, { useState } from "react";
import { Box, Button, Collapse, Typography } from "@mui/material";

export default function LabTestExpandCard({
  title,
  entries = [],
  currDarkThemeClass = '',
  sx = {},
  ...props
}) {
  const [expanded, setExpanded] = useState(false);
  const isDark = !!currDarkThemeClass;

  
  const handleHeaderClick = (e) => {
    
    if (e.target.closest('button')) return;
    setExpanded((prev) => !prev);
  };

  return (
    <Box
      sx={{
        bgcolor: isDark ? "rgba(255,255,255,0.1)" : "#ededed",
        borderRadius: 1,
        px: 2,
        py: 0.5,
        minHeight: "32px",
        border: `1px solid ${isDark ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)"}`,
        ...sx,
      }}
      {...props}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          cursor: "pointer",
        }}
        onClick={handleHeaderClick}
      >
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: 500,
            color: isDark ? "white" : "black",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            flex: 1,
            minWidth: 0,
          }}
        >
          {title}
        </Typography>
        <Button
          onClick={() => setExpanded((prev) => !prev)}
          sx={{
            color: isDark ? "white" : "black",
            fontWeight: 500,
            fontSize: "14px",
            minWidth: 0,
            ml: 2,
            p: 0,
            textTransform: "none",
          }}
        >
          {expanded ? "Close" : "See More"}
        </Button>
      </Box>
      <Collapse in={expanded}>
        <Box
          sx={{
            mt: 1,
            bgcolor: isDark ? "rgba(255,255,255,0.05)" : "#ededed",
            borderRadius: 1,
            p: 1,
            border: `1px solid ${isDark ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.3)"}`,
          }}
        >
          {entries.map((entry, i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                py: 0.2,
                px: 1,
                borderRadius: 1,
                transition: "background 0.2s",
                cursor: "pointer",
                "&:hover": {
                  bgcolor: isDark ? "rgba(255,255,255,0.15)" : "#e0e0e0",
                },
              }}
            >
              <Typography sx={{ fontSize: "13px", color: isDark ? "white" : "black" }}>
                {entry.key}
              </Typography>
              <Typography sx={{ fontSize: "13px", color: isDark ? "#ccc" : "#666" }}>
                {entry.value}
              </Typography>
            </Box>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
}